export const filteredParcelle = (state) => (ferme) => {
  return state.parcelle_list.filter((e) => e.ferme === ferme);
};
